import {Component, OnInit} from '@angular/core';
import {TheadColumn, TheadGroup} from "../../components/table/thead/thead-column";
import {TableSorter} from "../../components/table/thead/table-sorter";
import {Page, StoricoImportXml} from "../../model/Models";
import {ApiService} from "../../services/api.service";
import {saveAs} from "file-saver";
import {SessionService} from "../../services/session.service";

@Component({
  selector: 'app-importazionedati',
  templateUrl: './importazionedati.component.html',
  styleUrls: ['./importazionedati.component.css']
})
export class ImportazionedatiComponent implements OnInit {
  theadGroups: TheadGroup[];
  tableSorter: TableSorter = new TableSorter();
  pagina: Page<StoricoImportXml> = new Page<StoricoImportXml>();
  pgrouped: Map<any, any> | undefined;

  constructor(private apiService: ApiService, private sessionService: SessionService,) {
    this.theadGroups = this.theadGroupedInit();
    this.tableSorter.toggle('id');

  }

  ngOnInit(): void {
    this.loadStorico();
  }

  private theadGroupedInit(): TheadGroup[] {

    return [
      {header: '', columns: [new TheadColumn('timestamp', 'Data')]},
      {header: '', columns: [new TheadColumn('utente', 'Utente')]},
      {header: '', columns: [new TheadColumn('struttura', 'Struttura')]},
      {header: '', columns: [new TheadColumn('tipo_file', 'Tipo import')]},
      {header: '', columns: [new TheadColumn('report_scarto', 'File report')]},
      {header: '', columns: [new TheadColumn('nome_file', 'Nome file')]},
      {header: '', columns: [new TheadColumn('id', 'Id')]},
      {header: '', columns: [new TheadColumn('scarto_xsd', 'Errore xsd')]},
      {header: '', columns: [new TheadColumn('caricati', 'Record<br>caricati in<br> SISTeP')]},
      {
        header: 'Record scartati',
        columns: [
          new TheadColumn('esistenti', 'chiave già<br>presente<br>nel sistema'),
          new TheadColumn('errati', 'errati')
        ]
      },
      {header: '', columns: [new TheadColumn('totali', 'Totale<br>Record<br>processati')]}
    ];
  }

  changeOrder(event: any) {
    this.loadStorico();
  }

  loadStorico() {
    let struttura = this.sessionService.getSelectedStrutturaFromStorage()?.codice;
    this.apiService.getStoricoByStruttura(
      struttura!,
      this.pagina.number,
      this.pagina.size,
      this.tableSorter.orderByName(),
      this.tableSorter.orderByDirection()).subscribe(res => {
      this.pagina = res;
      this.pagina.loading = false;
      this.pgrouped = groupBy(res.content, v => v.timestamp);
      // console.log(this.pgrouped);
    });

  }

  cambiaPagina(event: any) {
    this.loadStorico();
  }

  downloadXmlImport(id: number, tipo: string, fileName: string) {
    this.apiService.downloadXmlimport(id, tipo).subscribe({

      next: (data: any): void => {

        let blob: Blob = new Blob();
        if (tipo == "storico_file") {
          blob = new Blob([data], {type: 'application/xml'});
        } else {
          blob = new Blob([data], {type: 'text/csv'});
        }
        saveAs(blob, fileName);

      }, error: (e): void => {

        alert(JSON.stringify(e));

      }

    });
  }

  protected readonly groupBy = groupBy;

  canDownload(item: any[]) {
    return item.some(value => value.scartoXsd) || item.some(value => value.errati > 0) || item.some(value => value.esistenti > 0);
  }
}

function groupBy(list: any[], keyGetter: (arg0: any) => any) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}
